import { SearchFilter } from '../../_shared/components/search-filters/search-filters.component';
import { CONTENT_GROUPS } from '../../_shared/components/cards/core/content-groups';
import { ContentGroup } from '../../../types/graphql';
import { SearchFacetFragment } from '../../_shared/components/cards/core/card-facet.fragment.generated';

const ALL = 'all';

export const LANDING_FILTERS_INITIAL: SearchFilter[] = [
  { id: ALL, label: 'landing-page.filter.all' },
  ...CONTENT_GROUPS,
];

export const LIMIT = 20;

export const contentGroupsOf = (filter: SearchFilter): ContentGroup[] | undefined =>
  filter?.id === ALL ? undefined : [filter.id as ContentGroup];

export const facetMatches = (filter: SearchFilter, facet: SearchFacetFragment): boolean =>
  filter?.id === ALL || facet.contentGroup === filter?.id;
